import { Action } from "redux";
import { ICart, ICartLineByProduct, IProductRequest } from '../../models/generated/cms.interface';
import { IAppCartLine } from "./cart";

export enum CartActionTypes {
    GET = "@@cart/GET",
    GET_NEW_CART = "@@cart/GET_NEW_CART",
    SET_DELETE_BUFFER = "@@cart/SET_DELETE_BUFFER",
    UPDATE_CART = "@@cart/UPDATE_BASKET",
    ADD_CART_LINE = "@@cart/ADD_CART_LINE",
    REINSTANTE_CART_LINE = "@@cart/REINSTANTE_CART_LINE",
    UPDATE_CART_LINE_QUANTITY = "@@cart/UPDATE_CART_LINE_QUANTITY",
    REINSTATE_CART_LINE = "@@cart/REINSTATE_CART_LINE",
    UPDATE_CART_COMPLETED = "@@cart/UPDATE_QUANTITY_COMPLETED",
    PLACE_ORDER = "@@cart/PLACE_ORDER",
    PLACE_ORDER_ERROR = "@@cart/PLACE_ORDER_ERROR",
    PLACE_ORDER_SUCCESS = "@@cart/PLACE_ORDER_SUCCESS",
    RESET_ORDER_STATE = "@@cart/RESET_ORDER_STATE",
    ADD_VOUCHER = "@@cart/ADD_VOUCHER",
    ADD_VOUCHER_ERROR = "@@cart/ADD_VOUCHER_ERROR",
    ADD_VOUCHER_SUCCESS = "@@cart/ADD_VOUCHER_SUCCESS",
    REMOVE_VOUCHER = "@@cart/REMOVE_VOUCHER",
}

export type ICartAction =
    IUpdateCartAction
    | IGetCartAction
    | IGetNewCartAction
    | IPlaceOrderAction
    | IPlaceOrderErrorAction
    | IPlaceOrderSuccessAction
    | IResetOrderStateAction
    | ISetDeleteBufferAction
    | IAddCartLineAction
    | IReinstateCartLineAction
    | IUpdateCartLineQuantityAction
    | IUpdateCartCompletedAction
    | IAddVoucherAction
    | IAddVoucherErrorAction
    | IAddVoucherSuccessAction
    | IRemoveVoucherAction;

export type IGetCartAction = Action<CartActionTypes.GET>;

export const getCart = (): IGetCartAction => ({
    type: CartActionTypes.GET,
});

export interface IGetNewCartAction extends Action<CartActionTypes.GET_NEW_CART> {
    onlyDelete?: boolean;
}

export const getNewCart = (onlyDelete?: boolean): IGetNewCartAction => ({
    type: CartActionTypes.GET_NEW_CART,
    onlyDelete,
});

export interface IAddCartLineAction extends Action<CartActionTypes.ADD_CART_LINE> {
    lines: IProductRequest[];
}

export const addCartLine = (lines: IProductRequest | IProductRequest[]): IAddCartLineAction => ({
    type: CartActionTypes.ADD_CART_LINE,
    lines: Array.isArray(lines) ? lines : [{ ...lines }],
});

export interface IUpdateCartLineQuantityAction extends Action<CartActionTypes.UPDATE_CART_LINE_QUANTITY> {
    productGroupId: number;
    quantity: number;
    withDebounce?: boolean;
}

export const updateCartLineQuantity = (productGroupId: number, quantity: number, withDebounce?: boolean): IUpdateCartLineQuantityAction => ({
    type: CartActionTypes.UPDATE_CART_LINE_QUANTITY,
    productGroupId,
    quantity,
    withDebounce,
});

export type IUpdateCartCompletedAction = Action<CartActionTypes.UPDATE_CART_COMPLETED>

export const updateCartCompleted = (): IUpdateCartCompletedAction => ({
    type: CartActionTypes.UPDATE_CART_COMPLETED,
});

export interface IReinstateCartLineAction extends Action<CartActionTypes.REINSTATE_CART_LINE> {
    productGroupId: number;
}

export const reinstateCartLine = (productGroupId: number): IReinstateCartLineAction => ({
    type: CartActionTypes.REINSTATE_CART_LINE,
    productGroupId,
});

/// TODO: CLEAN UP BELOW

export interface IUpdateCartAction extends Action<CartActionTypes.UPDATE_CART> {
    cart: ICart;
}

export interface IPlaceOrderAction extends Action<CartActionTypes.PLACE_ORDER> {
    deliveryAddress?: any;
    productReference?: string;
}
export type IPlaceOrderErrorAction = Action<CartActionTypes.PLACE_ORDER_ERROR>;
export type IPlaceOrderSuccessAction = Action<CartActionTypes.PLACE_ORDER_SUCCESS>;
export type IResetOrderStateAction = Action<CartActionTypes.RESET_ORDER_STATE>;

export interface ISetDeleteBufferAction extends Action<CartActionTypes.SET_DELETE_BUFFER> {
    lines?: IAppCartLine[];
    linesByProduct?: ICartLineByProduct[];
}

export const updateCart = (cart: ICart): IUpdateCartAction => ({
    type: CartActionTypes.UPDATE_CART,
    cart,
});

export const placeOrder = (deliveryAddress?: any, productReference?: string): IPlaceOrderAction => ({
    type: CartActionTypes.PLACE_ORDER,
    deliveryAddress,
    productReference
});

export const placeOrderError = (): IPlaceOrderErrorAction => ({
    type: CartActionTypes.PLACE_ORDER_ERROR,
});

export const placeOrderSuccess = (): IPlaceOrderSuccessAction => ({
    type: CartActionTypes.PLACE_ORDER_SUCCESS,
});

export const resetOrderState = (): IResetOrderStateAction => ({
    type: CartActionTypes.RESET_ORDER_STATE,
});

export const setDeleteBuffer = (lines?: IAppCartLine[], linesByProduct?: ICartLineByProduct[]): ISetDeleteBufferAction => ({
    type: CartActionTypes.SET_DELETE_BUFFER,
    lines,
    linesByProduct,
});

export interface IAddVoucherAction extends Action<CartActionTypes.ADD_VOUCHER> {
    voucherCode: string;
}
export const addVoucher = (voucherCode: string): IAddVoucherAction => ({
    type: CartActionTypes.ADD_VOUCHER,
    voucherCode,
});

export interface IRemoveVoucherAction extends Action<CartActionTypes.REMOVE_VOUCHER> {
    voucherCode: string;
}
export const removeVoucher = (voucherCode: string): IRemoveVoucherAction => ({
    type: CartActionTypes.REMOVE_VOUCHER,
    voucherCode,
});

export type IAddVoucherErrorAction = Action<CartActionTypes.ADD_VOUCHER_ERROR>;
export type IAddVoucherSuccessAction = Action<CartActionTypes.ADD_VOUCHER_SUCCESS>;
